export default {
    create_edit_package_edit_title: "Edit Package",
    create_edit_package_create_title: "Create Package",
    create_edit_package_success_create: "The package has been created",
    create_edit_package_success_edit: "The package has been edited",
    create_edit_package_name: "Name",
    create_edit_package_description: "Description",
    create_edit_package_brand: "Brand",
    create_edit_package_label: "Platform",
}